import { t } from '@lingui/core/macro';
import { BookingRecordDetailsCustomer } from '@navio/nsdk';
import { CustomDateFormats, getIsPaidInAdvance, NoddiDateFormats, noddiFormatDate } from 'noddi-util';

/** Prepaid says "paid" in the sentence, so no later step reads as a pending charge. */
export const getConfirmedStepDescription = (
  booking: Pick<
    BookingRecordDetailsCustomer,
    'hasCustomerVisit' | 'order' | 'deliveryWindowStartsAt' | 'deliveryWindowEndsAt'
  >
): string => {
  const isPaidInAdvance = getIsPaidInAdvance(booking.order);
  if (!booking.hasCustomerVisit) {
    return isPaidInAdvance ? t`Your booking has been confirmed and paid.` : t`Your booking has been confirmed.`;
  }

  const deliveryStartTime = noddiFormatDate(booking.deliveryWindowStartsAt, NoddiDateFormats.TIME);
  const deliveryEndTime = noddiFormatDate(booking.deliveryWindowEndsAt, NoddiDateFormats.TIME);
  const deliveryDate = noddiFormatDate(booking.deliveryWindowStartsAt, CustomDateFormats.FULL_DAY_MONTH);
  const deliveryTime = `${deliveryStartTime} - ${deliveryEndTime}`;
  const translatedDeliveryTime = t`${deliveryDate} between ${deliveryTime}`;
  return isPaidInAdvance
    ? t`Your booking has been confirmed and paid for ${translatedDeliveryTime}.`
    : t`Your booking has been confirmed for ${translatedDeliveryTime}.`;
};
